module.exports = __webpack_public_path__ + "static/media/logo1_bccy_blanco.19c85752.svg";